import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=048c436d&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=048c436d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048c436d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('048c436d')) {
      api.createRecord('048c436d', component.options)
    } else {
      api.reload('048c436d', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=048c436d&scoped=true&", function () {
      api.rerender('048c436d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2E9x1B5henl52/JS/comp/DateRangeExt.vue"
export default component.exports